import { Heading, Text, Grid, Box, Flex, Spacer } from '@chakra-ui/react'
import { useState } from 'react'
import { InfoCard } from '@/modules/teacher/components/InfoCard'
import { BranchType } from '@/shared/api/hooks/useBranches'
import { getFromLocalStorage } from '@/shared/utils/localStorageHelper'
import { useAggregate } from '@/modules/teacher/hooks'
import BranchDropdown from './BranchDropdown'

const today = new Date()

const TeacherCheckinStats = () => {
    const [branch] = useState(getFromLocalStorage<BranchType>('currentBranch'))

    const { data: aggregateData } = useAggregate({
        startDate: today,
        branchId: branch ? branch.value : ''
    })

    return (
        <>
            <Flex alignItems="center" gap="2" flexWrap="wrap">
                <Box p="2">
                    <Heading size="md" my={2}>
                        Checkin Summary
                    </Heading>
                    <Text color={'gray.600'}>
                        Dear teacher, we log your check-in and check-out information on
                        this page
                    </Text>
                </Box>
                <Spacer />
                <BranchDropdown />
            </Flex>

            <Grid
                p="2"
                gap={4}
                my={4}
                templateColumns={{
                    sm: 'repeat(1, minmax(0, 1fr))',
                    md: 'repeat(2, minmax(0, 1fr))',
                    xl: 'repeat(4, minmax(0, 1fr))'
                }}
            >
                <InfoCard
                    bg="green.50"
                    textColor="brand"
                    stats={aggregateData.Toddlers.totalCheckedIn}
                    icon={<>✅</>}
                    label="Toddlers Check-in"
                />
                <InfoCard
                    bg="green.100"
                    textColor="brand.400"
                    stats={aggregateData.Toddlers.totalCheckedOut}
                    icon={<>⛔</>}
                    label="Toddlers Check-out"
                />

                <InfoCard
                    bg="blue.50"
                    textColor="brand.400"
                    stats={aggregateData.PreSchool.totalCheckedIn}
                    icon={<>✅</>}
                    label="PreSchool Check-in"
                />
                <InfoCard
                    bg="blue.100"
                    textColor="brand.400"
                    stats={aggregateData.PreSchool.totalCheckedOut}
                    icon={<>⛔</>}
                    label="PreSchool Check-out"
                />

                <InfoCard
                    bg="orange.50"
                    textColor="brand.400"
                    stats={aggregateData.SchoolAge.totalCheckedIn}
                    icon={<>✅</>}
                    label="SchoolAge Check-in"
                />
                <InfoCard
                    bg="orange.100"
                    textColor="brand.400"
                    stats={aggregateData.SchoolAge.totalCheckedOut}
                    icon={<>⛔</>}
                    label="SchoolAge Check-out"
                />

                <InfoCard
                    bg="pink.50"
                    textColor="brand.400"
                    stats={aggregateData.Samuels.totalCheckedIn}
                    icon={<>✅</>}
                    label="Samuels Check-in"
                />
                <InfoCard
                    bg="pink.100"
                    textColor="brand.400"
                    stats={aggregateData.Samuels.totalCheckedOut}
                    icon={<>⛔</>}
                    label="Samuels Check-out"
                />

                <InfoCard
                    bg="purple.50"
                    textColor="brand.400"
                    stats={aggregateData.Teenagers.totalCheckedIn}
                    icon={<>✅</>}
                    label="Teenagers Check-in"
                />
                <InfoCard
                    bg="purple.100"
                    textColor="brand.400"
                    stats={aggregateData.Teenagers.totalCheckedOut}
                    icon={<>⛔</>}
                    label="Teenagers Check-out"
                />
            </Grid>
        </>
    )
}

export default TeacherCheckinStats
